import styled, { css } from 'styled-components'

import Box from 'components/Box'
import { ReactComponent as CheckIcon } from 'icons/check-12.svg'
import UnstyledCaption from 'components/Caption'

const checkboxSize = '14px'

export const CheckmarkIcon = styled(CheckIcon)`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  color: white;
  pointer-events: none;
`

export const Container = styled(Box)`
  display: flex;
  position: relative;
  margin-bottom: 0;
  line-height: 1.4;
  cursor: pointer;
`

interface CheckboxInputProps {
  checked?: boolean
}

export const CheckboxInput = styled.span<CheckboxInputProps>(
  ({ theme, checked }) => css`
    display: inline-block;
    vertical-align: middle;
    position: relative;

    width: ${checkboxSize};
    height: ${checkboxSize};
    padding: 0;
    margin-right: 12px;

    &:not(:last-child) {
      margin-right: 12px;
    }

    transition: background-color
      ${`${theme.transitions.duration[1]} ${theme.transitions.timing.easeOut}`};

    border-width: 1px;
    border-style: solid;
    border-color: ${theme.colors.border.dark.ultraHigh};
    background: ${theme.colors.background.light.base};
    border-radius: 3px;

    align-items: flex-start;
    justify-content: center;
    flex-shrink: 0;

    ${checked &&
    css`
      border-color: ${theme.colors.primaryTint[100]};
      background-color: ${theme.colors.primaryTint[100]};
    `}
  `
)

export const HiddenInput = styled.input`
  position: absolute;
  width: 100%;
  height: 100%;
  appearance: none;
  cursor: pointer;
`

interface CheckboxLabelProps {
  disabled: boolean
}

export const CheckboxLabel = styled(Box)<CheckboxLabelProps>(
  ({ theme, disabled }) => css`
    font-weight: ${theme.fontWeights.regular};
    opacity: ${disabled ? 0.5 : 1};
    line-height: 1.6; /* stylelint-disable-line scales/line-height */
    color: ${theme.colors.foreground.secondary[2]};
  `
)

export const CheckboxLabelText = styled.span(
  ({ theme }) => css`
    font-size: ${theme.fontSizes.small};
  `
)

export const Caption = styled(UnstyledCaption)(
  ({ theme }) => css`
    margin: 0;
    font-size: ${theme.fontSizes.smaller};
    color: ${theme.colors.foreground.secondary[4]};
    line-height: 1.3;
    padding-top: 2px; /* stylelint-disable-line scales/space */
  `
)

export const LoadingWrapper = styled.div`
  position: relative;
  display: inline-block;

  top: -3px;
  left: 8px;
`

export const SuccessWrapper = styled.div(
  ({ theme }) => css`
    position: relative;
    display: inline-block;

    top: 4px;
    left: 8px;

    color: ${theme.colors.state.positive};
  `
)
